module.exports = __webpack_public_path__ + "img/hansfordk.8c158581.jpg";